import Vue from 'vue'
import Vuex from 'vuex'
import video from './modules/video';
import organization from './modules/organization';
import siteInfo from './modules/siteInfo';
import constants from './modules/constants';
import utils from './modules/utils';
import translations from './modules/translations';

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
      video,
      organization,
      siteInfo,
      constants,
      utils,
      translations,
    }
})
